import React, { useEffect, useState } from "react";

import { MANAGER_ROLE } from "../../consts/member";

import { UserState, useUserContext } from "../../contexts/userContext";

export default function useEvacuationManger(): [
  boolean | undefined,
  boolean | undefined,
  { user: UserState },
  boolean | undefined
] {
  const [user] = useUserContext();
  const [isManager, setIsManager] = useState<boolean | undefined>(undefined);
  const [isUser, setIsUser] = useState<boolean | undefined>(undefined);
  const [isAdminOrMaster, setIsAdminOrMaster] = useState<boolean | undefined>(
    undefined
  );

  useEffect(() => {
    if (user?.isLoading === false && user?.roles) {
      setIsManager(
        [
          MANAGER_ROLE.ADMIN,
          MANAGER_ROLE.EVACUATION_MASTER,
          MANAGER_ROLE.EVACUATION_COM_ADMIN,
          MANAGER_ROLE.EVACUATION_DEP_ADMIN,
        ].some((adminRole) => user.roles?.includes(adminRole))
      );

      const isAdminOrMaster =
        user?.roles.includes(MANAGER_ROLE.ADMIN) ||
        user?.roles.includes(MANAGER_ROLE.EVACUATION_MASTER);
      setIsAdminOrMaster(isAdminOrMaster);
    }

    if (user?.isLoading === undefined) {
      setIsUser(false);
    } else {
      setIsUser(true);
    }
  }, [user]);

  return [isManager, isUser, { user }, isAdminOrMaster];
}
